import { render, staticRenderFns } from "./FontSmallButton.vue?vue&type=template&id=3c3e0f66&scoped=true&"
import script from "./FontSmallButton.ts?vue&type=script&lang=ts&"
export * from "./FontSmallButton.ts?vue&type=script&lang=ts&"
import style0 from "./FontSmallButton.css?vue&type=style&index=0&id=3c3e0f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e0f66",
  null
  
)

export default component.exports